import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import { IWorkingSlotUpdateQuery } from 'pages/menuWorkingSchedule/interfaces'

export const useWorkingScheduleService = () => {
  const { post } = useAxiosService()

  const updateWorkingSlot = async (
    query: IWorkingSlotUpdateQuery
  ): Promise<IResponse<any>> => {
    const response: any = await post(`/clinic/info`, query)
    return {
      ...response,
      data: response?.data
    } as IResponse<any>
  }
  return {
    updateWorkingSlot
  }
}
